export enum AggregateSizeFraction {
  Sizes4mmTo6_3mm = 'Sizes4mmTo6_3mm',
  Sizes4mmTo8mm = 'Sizes4mmTo8mm',
  Sizes6_3mmTo10mm = 'Sizes6_3mmTo10mm',
  Sizes8mmTo11_2mm = 'Sizes8mmTo11_2mm',
  Sizes10mmTo14mm = 'Sizes10mmTo14mm',
  Sizes11_2mmTo16mm = 'Sizes11_2mmTo16mm',
  Sizes16mmTo32mm = 'Sizes16mmTo32mm',
  Sizes31_5mmTo50mm = 'Sizes31_5mmTo50mm',
}

export enum IntermediateSieveSize {
  Sieve11_2mm = '11_2',
  Sieve12_5mm = '12_5',
}

export enum PassingIntermediateSieveRequirement {
  Pass30To40Percentage = 'Pass30To40Percentage',
  Pass45To55Percentage = 'Pass45To55Percentage',
  Pass50Percentage = 'Pass50Percentage',
  Pass60To70Percentage = 'Pass60To70Percentage',
}
